import React from 'react';
const marked = require('marked');

import lettuceLogo from '../assets/images/the-farm-project-lettuce-grow-logo.svg';

export default ({ data }) =>
    <div>
        <div className="hero">
            <div>
                <div className="hero__background" />
                <div className="hero__content">
                    <div className="hero__title">
                        {data.heroHeading}
                    </div>
                    <div className="hero__copy">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: marked(data.heroText.heroText, {
                                    gfm: true,
                                    breaks: true,
                                }),
                            }}
                        />
                    </div>
                    <div className="collaborations__link">
                        <a href={data.heroUrl} target="_blank">
                            {data.heroCallToActionText}
                            <i className="fas fa-chevron-right" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="yourfoodsroots">
            <a target="_blank" href={data.mainUrl}>
                <img src={lettuceLogo} />
            </a>
        </div>
    </div>;



// WEBPACK FOOTER //
// ./src/components/collaborations-hero.js